(function( $ ) {
    'use strict';

    $( window ).load(function() {
        if (window.location.href.indexOf("account-details") === -1) {
            // only run this on the account-details page
            return;
        }

        const firstName = document.querySelector("#account-first-name");
        const lastName = document.querySelector("#account-last-name");
        const displayName = document.querySelector("#account-display-name");

        function updateDisplayName() {
            displayName.value = firstName.value + " " + lastName.value;
        }

        updateDisplayName();

        firstName.addEventListener("input", function () {
            updateDisplayName();
        })

        lastName.addEventListener("input", function () {
            updateDisplayName();
        })


        const showPasswordIcons = document.querySelectorAll(".show-password-input");
        showPasswordIcons.forEach((icon) => {
            icon.addEventListener("click", () => {
                icon.classList.toggle("display-password");
                updateTypeInputPassword()
            })
        })

        function updateTypeInputPassword() {
            const passwordInputs = document.querySelectorAll(".input-password");
            passwordInputs.forEach((input) => {
                const isDisplayPassword = input.parentElement.querySelector(".display-password")
                if(isDisplayPassword) {
                    input.type = "text"
                } else {
                    input.type = "password"
                }
            })
        }
    });
})( jQuery );
